import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import ReactMarkdown from 'react-markdown';

import './style.css';

const renderParagraph = ({ children }) => {
  if (
    children &&
    children[0] &&
    children.length === 1 &&
    children[0].props &&
    children[0].props.src
  ) {
    // rendering media without p wrapper

    return children;
  }

  return <p>{children}</p>;
};

renderParagraph.propTypes = {
  children: PropTypes.node,
};

renderParagraph.defaultProps = {
  children: null,
};

const RichText = ({ text, children, className, ...rest }) => {
  const customClassName = classNames('rich-text', className);
  return (
    <div className={customClassName}>
      <ReactMarkdown
        source={text}
        renderers={{
          paragraph: renderParagraph,
        }}
        {...rest}
      />
      {children}
    </div>
  );
};

RichText.propTypes = {
  className: PropTypes.string,
  text: PropTypes.string,
  children: PropTypes.node,
  limit: PropTypes.bool,
};

RichText.defaultProps = {
  className: undefined,
  text: undefined,
  limit: false,
  children: null,
};

export default RichText;
